<div class="counts">
  <sc-flex>
    <div class="bar total">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.total-count"></sc-dictionary-label>
      {{total}}
    </div>
    @for (count of counts; track $index) {
    <div class="bar {{ 'theming-rule-' + count.ruleId }}" [style.flex-grow]="count.count">
      <sc-flex centered>
        <div class="label">
          {{count.ruleName}}
        </div>
        <sc-content-spacer half></sc-content-spacer>
        <div class="value">
          {{count.count}}
        </div>
      </sc-flex>
    </div>
    }
  </sc-flex>
</div>
